/*
 * Where someone was going when they were asked to sign in, as the sign-in screen names it: a link
 * from Slack to a ticket reads as the ticket's key, anything else as its path.
 */

const ticketPage = /^\/projects\/([A-Z]+)\/(\d+)$/

/**
 * What the sign-in screen says a signed-out visitor was opening, or nothing when they were only
 * opening Beacon itself. `next` is the path, search and hash they asked for.
 */
export function destinationOf(next: string): string | undefined {
  const path = next.split(/[?#]/)[0] ?? ""
  if (path === "" || path === "/") return undefined
  const [, key, number] = ticketPage.exec(path) ?? []
  return key && number ? `${key}-${number}` : path
}
